<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit, reset }">
      <b-form
        ref="userForm"
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="reset"
      >
        <b-form-group class="mb-4">
          <label>Email Address <span class="red">*</span></label>
          <validation-provider
            name="email address"
            rules="required|email"
            v-slot="validationContext"
          >
            <b-form-input
              :state="getValidationState(validationContext)"
              placeholder="Enter Email Address"
              v-model="user.email"
              trim
            ></b-form-input>
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>

        <b-form-group class="mb-4">
          <label>Mobile Number <span class="optional">(Optional)</span></label>
          <validation-provider
            name="user mobile number"
            rules="ph-mobile"
            v-slot="validationContext"
          >
            <b-form-input
              :state="getValidationState(validationContext)"
              placeholder="Enter Mobile Number (ex. 09171113333)"
              v-model="user.phone_number"
              trim
            ></b-form-input>
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>

        <b-form-group class="mb-4">
          <label>Full Name <span class="red">*</span></label>
          <validation-provider
            name="full name"
            rules="required"
            v-slot="validationContext"
          >
            <b-form-input
              :state="getValidationState(validationContext)"
              placeholder="Enter Full Name"
              v-model="user.name"
              trim
            ></b-form-input>
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>

        <b-form-group class="mb-4">
          <label>Password <span class="red">*</span></label>
          <validation-provider
            name="password"
            rules="required|verify_password"
            v-slot="validationContext"
          >
            <b-input-group>
              <template #append>
                <b-input-group-text
                  class="toggle-password"
                  :class="{
                    'input-text-red':
                      getValidationState(validationContext) === false,
                    'input-text-green':
                      getValidationState(validationContext) === true,
                  }"
                  @click="() => (isShowPassword = !isShowPassword)"
                  >&nbsp;<i
                    class="far"
                    :class="{
                      'fa-eye': isShowPassword,
                      'fa-eye-slash': !isShowPassword,
                    }"
                  ></i
                ></b-input-group-text>
              </template>
              <b-form-input
                class="mb-2 no-border-right"
                :state="getValidationState(validationContext)"
                :type="isShowPassword ? 'text' : 'password'"
                autocomplete="new-password"
                name="password"
                placeholder="Enter Password"
                v-model="user.password"
                trim
              ></b-form-input>
            </b-input-group>

            <div class="password-verification">
              <div class="mb-1">Password must include:</div>
              <b-row>
                <b-col :class="{ green: validationData.oneCapital }" cols="4"
                  ><i
                    :class="{ grey: !validationData.oneCapital }"
                    class="fas fa-check-circle"
                  ></i>
                  Atleast 1 capital letter</b-col
                >
                <b-col :class="{ green: validationData.oneNumber }" cols="4"
                  ><i
                    :class="{ grey: !validationData.oneNumber }"
                    class="fas fa-check-circle"
                  ></i>
                  Atleast 1 number</b-col
                >
                <b-col cols="4"></b-col>
                <b-col :class="{ green: validationData.oneLower }" cols="4"
                  ><i
                    :class="{ grey: !validationData.oneLower }"
                    class="fas fa-check-circle"
                  ></i>
                  Atleast 1 lower letter</b-col
                >
                <b-col :class="{ green: validationData.oneSymbol }" cols="5"
                  ><i
                    :class="{ grey: !validationData.oneSymbol }"
                    class="fas fa-check-circle"
                  ></i>
                  Atleast 1 symbol (ex: ?@#)</b-col
                >
                <b-col cols="3"></b-col>
                <b-col
                  :class="{ green: validationData.eightCharacter }"
                  cols="4"
                  ><i
                    :class="{ grey: !validationData.eightCharacter }"
                    class="fas fa-check-circle"
                  ></i>
                  Atleast 8 characters</b-col
                >
                <b-col cols="4"></b-col>
                <b-col cols="4"></b-col>
              </b-row>
            </div>
          </validation-provider>
        </b-form-group>

        <b-form-group class="mb-4">
          <label>Confirm Password <span class="red">*</span></label>
          <validation-provider
            name="confirm password"
            rules="required|confirmed:password"
            v-slot="validationContext"
          >
            <b-input-group>
              <template #append>
                <b-input-group-text
                  class="toggle-password"
                  :class="{
                    'input-text-red':
                      getValidationState(validationContext) === false,
                    'input-text-green':
                      getValidationState(validationContext) === true,
                  }"
                  @click="
                    () => (isShowConfirmPassword = !isShowConfirmPassword)
                  "
                  >&nbsp;<i
                    class="far"
                    :class="{
                      'fa-eye': isShowConfirmPassword,
                      'fa-eye-slash': !isShowConfirmPassword,
                    }"
                  ></i
                ></b-input-group-text>
              </template>
              <b-form-input
                class="no-border-right"
                :state="getValidationState(validationContext)"
                :type="isShowConfirmPassword ? 'text' : 'password'"
                name="confirm_password"
                autocomplete="new-password"
                placeholder="Confirm Password"
                v-model="user.confirmPassword"
                trim
              ></b-form-input>
            </b-input-group>
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>

        <b-button class="w-100" type="submit" variant="primary">Next</b-button>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      isShowPassword: false,
      isShowConfirmPassword: false,
      user: this.value,
    };
  },
  computed: {
    validationData() {
      var validationData = {
        oneCapital: this.user.password && this.user.password.match(/[A-Z]/),
        oneNumber: this.user.password && this.user.password.match(/[0-9]/),
        oneLower: this.user.password && this.user.password.match(/[a-z]/),
        oneSymbol:
          this.user.password &&
          //eslint-disable-next-line
          this.user.password.match(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/),
        eightCharacter: this.user.password && this.user.password.length >= 8,
      };

      return validationData;
    },
  },
  watch: {
    user: {
      handler(val) {
        this.$emit("update", val);
      },
      deep: true,
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    onSubmit() {
      this.$emit("submit");
    },
  },
};
</script>

<style>
.password-verification {
  font-size: 11px;
  font-weight: 500;
}

.toggle-password {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  cursor: pointer;
  background: none;
  color: #e1e1e1;
}

.no-border-right {
  border-right: none;
}

.input-text-green {
  border-color: #51d28c;
}

.input-text-red {
  border-color: #f34e4e;
}
</style>